import api from "@/services/api";

export default {
  getList(params) {
    return api.get('/report/contract-status', { params });
  },
  exportExcel(params) {
    return api.get('/report/contract-status/export-excel', {
      params,
      responseType: 'blob',
    });
  },
};
